import { NavLink, useLocation, Link } from 'react-router-dom'
import { useContext } from 'react'

import { projectContext, spaceRemover, useTranslate } from '../../lib'

import '../../styles/sideBar.scss'
import ArrowLeft from '../../images/arrow-left-blue.svg';

export default function SideBarGenAI(props) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  let location = useLocation()
  let navigationLinks;
  const { t } = useTranslate();

  if(props.project != undefined && !props.project){
    navigationLinks = [
      // {name: "Home", route: "/"},
      // {name: "Report", route: `/${spaceRemover(selectedProject.name)}/Report`},
      {name: "Users", displayName: t('common.users'), route: `/${spaceRemover(selectedProject.name)}/UsersGenAI`, active: props.active},
      {name: "Guide", displayName: t('common.guide'), route: `/${spaceRemover(selectedProject.name)}/GuideGenAI`, active: props.active},
      {name: "Settings", displayName: t('common.settings'), route: `/${spaceRemover(selectedProject.name)}/SettingsGenAI`, active: props.active},
      {name: "Logs", displayName: t('common.logs'), route: `/${spaceRemover(selectedProject.name)}/changes-logsGenAI`, active: props.active},
    ]
  }else{
    navigationLinks = [
      // {name: "Home", route: "/"},
      {name: "Project", displayName: t('common.project'), route: `/${spaceRemover(selectedProject.name)}/GenAI`, active: props.active}, 
      {name: "Users", displayName: t('common.users'),  route: `/${spaceRemover(selectedProject.name)}/UsersGenAI`, active: props.active},
      {name: "Guide", displayName: t('common.guide'), route: `/${spaceRemover(selectedProject.name)}/GuideGenAI`, active: props.active},
      {name: "Settings", displayName: t('common.settings'), route: `/${spaceRemover(selectedProject.name)}/SettingsGenAI`, active: props.active}, 
      {name: "Logs", displayName: t('common.logs'), route: `/${spaceRemover(selectedProject.name)}/changes-logsGenAI`, active: props.active},
    ]
  }

  return (
    // <aside style={{height: 'fit-content', marginTop: "9%"}}>
    //   {/* <div className='icon bg-[#ffffff00]' style={{backgroundColor: "#ffffff00"}}></div> */}
    //   {navigationLinks.map(({name, route, active}, index) => {
    //     return (
    //       <NavLink to={route} key={index} className={ active === name ? "active" : "none"}>
    //         <img
    //           src={`/icons/${name}.png`}
    //           alt={name}
    //           // style={{minWidth: 10, width: 22}}
    //         />
    //         <p>{name}</p>
    //       </NavLink>
    //     )
    //   })}
    // </aside>


        <aside style={{height: 'fit-content', marginTop: "9%"}}>
          <Link to={'/projects'} style={{marginTop: -60}} className='link_back_projects'>
            <img src={ArrowLeft} className='img_back_projects'></img>
            <p style={{color: 'gray', fontSize: 12}}>{t('menu.listOfProjects')}</p>
          </Link>
      {/* <div className='icon bg-[#ffffff00]' style={{backgroundColor: "#ffffff00"}}></div> */}
      {navigationLinks.map(({name, route, active}, index) => {
        return (
          <NavLink to={route} key={index} className={ active === name ? "active" : "none"}>
            <img
              src={`/icons/${name}.png`}
              alt={name}
              // style={{minWidth: 10, width: 22}}
            />
            <p>{name}</p>
          </NavLink>
        )
      })}
    </aside>
  )
}
